import React from "react";

function SvgComponent() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="M18.333 17.5H1.666v-1.667h.833v-12.5c0-.46.373-.833.834-.833h11.666c.46 0 .834.373.834.833V7.5h1.666v8.333h.834V17.5zm-4.167-1.667h1.667V9.167h-5v6.666h1.666v-5h1.667v5zm0-8.333V4.167h-10v11.666h5V7.5h5zM5.833 9.167h1.666v1.666H5.833V9.167zm0 3.333h1.666v1.667H5.833V12.5zm0-6.667h1.666V7.5H5.833V5.833z"
      ></path>
    </svg>
  );
}

export default SvgComponent;
